import { fetch } from "@/helpers/fetch"; //引用fetch.js
/**
 * get
 * -------------------------------------获取openid---------------------------------------------
 *  code 返回的code
 *  type 返回的type
 */
export function getEventPushDetail({id}) {
    return fetch({
        url: `/api/wechat/event/push/${id}`,
        method: 'get'
        // params: data
    })
}